import React from 'react';
import {connect} from "react-redux";

import {isChildAttr, getFlattenAttrs, getAttrLink} from "../../helpers/attributes";

import Navigation from "../Navigation";

const NavigationAttributes = (props) => {

  const {attributes: rawAttributes, match, params, ...rest} = props,
    attributes = getFlattenAttrs(rawAttributes),
    currAttrIndex = attributes.findIndex(attr => attr.slug === match.params.attrSlug),
    currRawAttrIndex = rawAttributes.findIndex(attr => attr.slug === match.params.attrSlug);

  let prevAttr = attributes[currAttrIndex - 1],
    nextAttr = attributes[currAttrIndex + 1];

  if (prevAttr && isChildAttr(prevAttr) && params[prevAttr.parent].price === 0) {
    prevAttr = rawAttributes[currRawAttrIndex - 1];
  }

  if (nextAttr && isChildAttr(nextAttr) && params[nextAttr.parent].price === 0) {
    nextAttr = rawAttributes[currRawAttrIndex + 1];
  }

  return (
    <Navigation
      prevLink={prevAttr ? getAttrLink(prevAttr.slug) : undefined}
      nextLink={nextAttr ? getAttrLink(nextAttr.slug) : '/summary'}
      nextText={nextAttr ? nextAttr.nextStepText : 'Weiter zur Übersicht'}
      {...rest}
    />
  );
};

export default connect(
  state => ({
    attributes: state.attributes,
    params: state.params
  })
)(NavigationAttributes);